import { render, staticRenderFns } from "./PurchaseReceivingIndex.vue?vue&type=template&id=6e63bbd9&"
import script from "./PurchaseReceivingIndex.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceivingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports